import { ELEMENT_CATALOG } from './icons';
import type { PlacedItem } from './types';

export type FloorPlanLayer = 'lighting' | 'sockets' | 'appliances' | 'blocks';

export function groupOf(type: string): FloorPlanLayer {
  if (type === 'custom_block') return 'blocks';
  const group = ELEMENT_CATALOG[type]?.group;
  if (group === 'light' || group === 'switch' || group === 'master') return 'lighting';
  if (group === 'socket') return 'sockets';
  return 'appliances';
}

export function layerOfItem(item: PlacedItem): FloorPlanLayer {
  if (item.blockId?.trim()) return 'blocks';
  return groupOf(item.type);
}
